import React from 'react';
import styled from 'styled-components';
import { BrowserRouter } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';

import { MainComponent } from './components/auth/MainComponent';
import { CookieBanner } from './components/CookieBanner';

const Root = styled.div`
  display: flex;
  height: 100vh;
  overflow: auto;
  flex-direction: column;
`;

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Root>
        <CssBaseline />

        <MainComponent />
      </Root>
      <CookieBanner />
    </BrowserRouter>
  );
};

export default App;
